module.exports = __webpack_public_path__ + "img/icone-restaurantes.44633aae.svg";